<script setup lang="ts">
import { OverlayBadge } from '@dashhudson/dashing-ui/badge';
import { Button } from '@dashhudson/dashing-ui/button';
import { useDrawer } from '@dashhudson/dashing-ui/drawer';

// TEMP (May 2026): release-note notification disabled to stay under the Contentful API budget. See sc#195003.
// import { useReleasePanelNotification } from '@/composables/useReleasePanelNotification';

const { launchDrawer } = useDrawer();
// const { hasNewReleaseNotes, markAsSeen } = useReleasePanelNotification();

function openReleasePanel() {
  // markAsSeen();
  launchDrawer({ name: 'releaseHub' });
}
</script>

<template>
  <OverlayBadge :show="false" size="xs" badge-class="-translate-x-[12px] translate-y-[9px]">
    <Button severity="utility" icon="gift" size="lg" @click="openReleasePanel" />
  </OverlayBadge>
</template>
